import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'
import React, { useEffect, useState } from 'react'
import { sortAs } from 'react-pivottable/Utilities'
import { connect } from 'react-redux'
import {
  FavouriteEditModal,
  PreferencesTableModal,
  ProgressBar,
  TopTableActions,
} from 'modules/core/components'
import {
  handleSave,
  handleSavePrimary,
} from 'modules/control/containers/ControlDetail/components/Evolution/utils'
import { Dropdown, Menu, message, notification, Spin } from 'antd'
import { CommentOutlined } from '@ant-design/icons'
import forecast from '../../../../../index'
import control from 'modules/control'
import configuration from 'modules/configuration'
import login from 'modules/login'
import _, { isEqual } from 'lodash'
import { handleDelete } from '../utils'

import PlaneTableUX from 'components/PivotTable/PlaneTableUX'
import PlaneTableRenderers from 'components/PivotTable/Renderers/Evolution/Plane'

import PivotTableUX from 'components/PivotTable/PivotTableUX'
import PivotTableRenderers from 'components/PivotTable/Renderers/Evolution/Tree'

import { useTranslation } from 'react-i18next'
import { generateMessageError, getHashTable, getValue } from 'modules/core/utils'
import { GENERAL } from 'modules/core/constants'
import TableRenderers from 'components/PivotTable/Renderers/Comparative/TableRenderers'
import { useParams } from 'react-router-dom'
import numeral from 'numeral'

const DEFAULT_FORMAT_CREATE = {
  'Suma (Decimales)': 'float',
  'Suma (Enteros)': 'int',
  'Suma (Miles)': 't',
  'Suma (Millones)': 'm',
}

const DEFAULT_FORMAT_SET = {
  float: 'Suma (Decimales)',
  int: 'Suma (Enteros)',
  t: 'Suma (Miles)',
  m: 'Suma (Millones)',
}

const getRowAuxName = (rows, allDimensionsList) => {
  return rows.map((row) => {
    if (row === 'Linea de reporte') {
      return 'Linea de reporte'
    } else if (row === 'Proyecciones') {
      return 'Proyecciones'
    } else if (row === 'Fecha') {
      return 'Fecha'
    } else if (row === 'Moneda Origen') {
      return 'Moneda Origen'
    } else {
      const dimension = allDimensionsList.find((el) => parseInt(row) === el.id)
      return dimension ? dimension.name_origin : ''
    }
  })
}

const getColsAuxName = (columns, allDimensionsList) => {
  return columns.map((col) => {
    if (col === 'Linea de reporte') {
      return 'Linea de reporte'
    } else if (col === 'Proyecciones') {
      return 'Proyecciones'
    } else if (col === 'Fecha') {
      return 'Fecha'
    } else if (col === 'Moneda Origen') {
      return 'Moneda Origen'
    } else {
      const dimension = allDimensionsList.find((el) => parseInt(col) === el.id)
      return dimension ? dimension.name_origin : ''
    }
  })
}

const getRowAuxId = (settings, allDimensionsList) => {
  return (
    !_.isEmpty(settings) &&
    settings.rows.map((row) => {
      if (row === 'Linea de reporte') {
        return 'Linea de reporte'
      } else if (row === 'Proyecciones') {
        return 'Proyecciones'
      } else if (row === 'Fecha') {
        return 'Fecha'
      } else if (row === 'Moneda Origen') {
        return 'Moneda Origen'
      } else {
        const id = allDimensionsList.find((el) => el.name_origin === row).id
        return id.toString()
      }
    })
  )
}

const getColsAuxId = (settings, allDimensionsList) => {
  return (
    !_.isEmpty(settings) &&
    settings.cols.map((col) => {
      if (col === 'Linea de reporte') {
        return 'Linea de reporte'
      } else if (col === 'Proyecciones') {
        return 'Proyecciones'
      } else if (col === 'Fecha') {
        return 'Fecha'
      } else if (col === 'Moneda Origen') {
        return 'Moneda Origen'
      } else {
        const id = allDimensionsList.find((el) => el.name_origin === col)
          ? allDimensionsList.find((el) => el.name_origin === col).id
          : null
        return id.toString()
      }
    })
  )
}

const ComparisonPivotTable = ({
  setPeriodTableSettings,
  periodTableSettings,
  download,
  globalProjectionId,
  allDimensionsList,
  isComparisonLoading,
  tableLoading,
  reportId,
  onRefetch,
  dataComparativeForecastReport,
  fetchLayoutList,
  layoutList,
  createLayout,
  deleteLayout,
  hasComment,
  setHasComment,
  loggedUser,
  setDataComments,
  dataComments,
  onRefetchComments,
  loadingComments,
  createComment,
  removeNewComment,
  showProgressBar,
  currencyData,
  localReferenceBase,
  defaultPhase,
  tableKey,
  hashComparison,
  showTableqp,
  setShowTableqp,
}) => {
  const enabledPlaneTable = useFeatureIsOn('feature-plane-table-custom')
  const formatBaseNumber = useFeatureValue('format-number-table', 'Suma (Decimales)')
  let { periodId, forecastId } = useParams()
  const [settings, setSettings] = useState({})
  const [showPopover, setShowPopover] = useState(false)
  const [favouriteName, setFavouriteName] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [isLayoutLoading, setIsLayoutLoading] = useState(false)
  const [viewSelect, setViewSelect] = useState({})
  const [viewComment, setViewComment] = useState(false)
  const [isCommentSaving, setIsCommentSaving] = useState(false)
  const [valueReferenceBase, setValueReferenceBase] = useState('BASE')
  const [showEdit, setShowEdit] = useState(false)
  const [showModalEdit, setShowModalEdit] = useState(false)
  const [newName, setNewName] = useState('')
  const [rowId, setRowId] = useState(null)
  const [hash, setHash] = useState(null)
  const [showPreferenceModal, setShowPreferenceModal] = useState(false)
  const { dataSource, linesOrder, linesTotal, linesRatio, linesRatioN } =
    dataComparativeForecastReport
  const { t } = useTranslation()

  const key = window.location.pathname.replaceAll('/', '-')

  var queryString = window.location.search
  var urlParams = new URLSearchParams(queryString)
  var table = urlParams.get('table')

  useEffect(() => {
    if (table) {
      const data = !isEqual(hash, table) && hash !== null ? hash : table
      const json = Buffer.from(data, 'base64').toString()
      const dataTable = JSON.parse(json)
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...dataTable.config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })
    }
  }, [table, hash])

  useEffect(() => {
    const { data, tableOptions, hiddenFromDragDrop, ...restProps } = settings
    if (!_.isEmpty(restProps) && showTableqp) {
      window.history.replaceState(
        null,
        '',
        `/forecast/${periodId}/${forecastId}/forecastglobal/${globalProjectionId}/${
          currencyData.id
        }/${reportId}/${tableKey}/${defaultPhase}?${
          hashComparison ? `comparison=${hashComparison}` : ''
        }&table=${getHashTable(settings)}`,
      )
    }
  }, [
    settings,
    defaultPhase,
    periodId,
    forecastId,
    globalProjectionId,
    currencyData,
    reportId,
    tableKey,
    hashComparison,
    showTableqp,
  ])

  useEffect(() => {
    setSettings((prevState) => {
      return { ...prevState, data: dataSource }
    })
  }, [dataSource])

  useEffect(() => {
    setIsLayoutLoading(true)
    fetchLayoutList('forecastoverallbudget', `${globalProjectionId}-${reportId}-coparations`).then(
      () => {
        setIsLayoutLoading(false)
        !table && setSettings({})
      },
    )
  }, [fetchLayoutList, globalProjectionId, reportId, table])

  useEffect(() => {
    const defaultLayout = layoutList?.values.find((el) => el.primary)
    setViewSelect(defaultLayout)
  }, [layoutList?.values])

  useEffect(() => {
    if (
      layoutList?.values.length > 0 &&
      !_.isEmpty(viewSelect) &&
      allDimensionsList.length > 0 &&
      !table
    ) {
      setSettings((prevState) => {
        return {
          ...prevState,
          ...viewSelect.config,
          cols:
            getColsAuxName(viewSelect.config.columns, allDimensionsList).length > 0
              ? getColsAuxName(viewSelect.config.columns, allDimensionsList)
              : ['Proyecciones'],
          rows: getRowAuxName(viewSelect.config.rows, allDimensionsList),
          aggregatorName: DEFAULT_FORMAT_SET[viewSelect.config.default_format],
          vals: [viewSelect.config.default_value],
        }
      })
    }
  }, [allDimensionsList, layoutList?.values, viewSelect, table])

  useEffect(() => {
    const defaultTableOptions = {
      linesOrder: linesOrder,
      linesTotal: linesTotal,
      linesRatio: linesRatio,
      linesRatioN: linesRatioN,
      referenceBase: valueReferenceBase,
    }

    setValueReferenceBase(getValue(localReferenceBase))
    if (!_.isEmpty(settings)) {
      setSettings((prevState) => ({
        ...prevState,
        tableOptions: {
          ...prevState.tableOptions,
          ...defaultTableOptions,
          referenceBase: getValue(localReferenceBase),
        },
      }))
    }
    // eslint-disable-next-line
  }, [localReferenceBase, linesOrder, linesTotal, linesRatio, linesRatioN, valueReferenceBase])

  const onClose = () => {
    setIsSaving(false)
    setShowPopover(false)
    setFavouriteName('')
  }

  const onCreate = () => {
    const data = {
      row_order: 0,
      column_order: 1,
      default_value: settings.vals[0],
      default_format: DEFAULT_FORMAT_CREATE[settings.aggregatorName],
      rows: getRowAuxId(settings, allDimensionsList),
      columns: getColsAuxId(settings, allDimensionsList),
    }

    return createLayout(
      'forecastoverallbudget',
      `${globalProjectionId}-${reportId}-coparations`,
      favouriteName,
      { config: data },
    )
  }

  const defaultData = !_.isEmpty(viewSelect) && {
    ...viewSelect.config,
    rows: getRowAuxName(viewSelect.config.rows, allDimensionsList),
    columns: getColsAuxName(viewSelect.config.columns, allDimensionsList),
    default_format: DEFAULT_FORMAT_SET[viewSelect.config.default_format],
  }
  const defaultSettings = !_.isEmpty(settings) && {
    rows: settings?.rows,
    columns: settings?.cols || ['Proyecciones'],
    row_order: settings?.row_order,
    column_order: settings?.column_order,
    default_value: settings?.vals ? settings.vals[0] : '',
    default_format: settings?.aggregatorName,
  }

  const onSavePrimary = (data) => {
    const dataAux = layoutList?.values.find((el) => el.name === data.name)
    return createLayout(
      'forecastoverallbudget',
      `${globalProjectionId}-${reportId}-coparations`,
      dataAux.name,
      { ...dataAux, primary: true },
    )
  }

  const renderTable = () => {
    if (enabledPlaneTable) {
      return (
        <Dropdown
          trigger={['contextMenu']}
          overlay={
            <Menu>
              {GENERAL.OPTION_COMMENT.map((el) => (
                <Menu.Item
                  key={el.key}
                  icon={<CommentOutlined />}
                  onClick={() => {
                    setViewComment(true)
                    setHasComment({ type: 'table', data: !hasComment.table })
                  }}
                >
                  {t(el.label)}
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <div style={{ width: '100%' }}>
            <PlaneTableUX
              renderers={Object.assign({}, PlaneTableRenderers)}
              data={dataSource}
              onChange={(s) => {
                setSettings(s)
                setHash(getHashTable(s))
                setShowTableqp(true)
              }}
              numberFormat={(val) =>
                numeral(val).format(
                  `0,0.${'0'.repeat(loggedUser?.format_number?.decimal_places_to_show)}`,
                )
              }
              vals={settings.default_value ? [settings.default_value] : ['amount']}
              cols={['Proyecciones']}
              rows={['Linea de reporte']}
              aggregatorName={settings.default_format || formatBaseNumber}
              hiddenFromDragDrop={['amount', 'price', 'quantity']}
              hiddenFromAggregators={
                dataSource[0] &&
                dataSource[0].filter((el) => el !== 'amount' && el !== 'price' && el !== 'quantity')
              }
              sorters={{
                Proyecciones: sortAs(['BASE', 'TOP_DOWN', 'BOTTOM_UP', 'CLOSING']),
              }}
              tableOptions={{
                linesOrder: linesOrder,
                linesTotal: linesTotal,
                linesRatio: linesRatio,
                linesRatioN: linesRatioN,
              }}
              tableFilter={{}}
              plotlyConfig={{
                responsive: true,
              }}
              {...settings}
            />
          </div>
        </Dropdown>
      )
    }

    return (
      <Dropdown
        trigger={['contextMenu']}
        overlay={
          <Menu>
            {GENERAL.OPTION_COMMENT.map((el) => (
              <Menu.Item
                key={el.key}
                icon={<CommentOutlined />}
                onClick={() => {
                  setViewComment(true)
                  setHasComment({ type: 'table', data: !hasComment.table })
                }}
              >
                {t(el.label)}
              </Menu.Item>
            ))}
          </Menu>
        }
      >
        <div style={{ width: '100%' }}>
          <PivotTableUX
            renderers={Object.assign({}, TableRenderers)}
            data={dataSource}
            onChange={(s) => {
              setSettings(s)
              setHash(getHashTable(s))
              setShowTableqp(true)
            }}
            numberFormat={(val) =>
              numeral(val).format(
                `0,0.${'0'.repeat(loggedUser?.format_number?.decimal_places_to_show)}`,
              )
            }
            vals={settings.default_value ? [settings.default_value] : ['amount']}
            cols={['Proyecciones']}
            rows={['Linea de reporte']}
            aggregatorName={settings.default_format || formatBaseNumber}
            hiddenFromDragDrop={['amount', 'price', 'quantity']}
            hiddenFromAggregators={
              dataSource[0] &&
              dataSource[0].filter((el) => el !== 'amount' && el !== 'price' && el !== 'quantity')
            }
            sorters={{
              Proyecciones: sortAs(['BASE', 'TOP_DOWN', 'BOTTOM_UP', 'CLOSING']),
            }}
            tableOptions={{
              linesOrder: linesOrder,
              linesTotal: linesTotal,
              linesRatio: linesRatio,
              linesRatioN: linesRatioN,
              referenceBase: valueReferenceBase,
            }}
            tableFilter={{}}
            plotlyConfig={{
              responsive: true,
            }}
            {...settings}
          />
        </div>
      </Dropdown>
    )
  }

  const handleCreate = ({ text, usersIds, idComment = null, setIsNewThread }) => {
    const dataa = {
      text,
      key: `${key}-table-comparison-${reportId}`,
      module: key,
      mentions: usersIds,
      ...(idComment && {
        parent: idComment,
      }),
    }
    setIsCommentSaving(true)
    createComment(dataa)
      .then(() =>
        onRefetchComments().then(() => {
          message.success(t('FEEDBACK_SAVE_CHANGES_SUCCES'), 8)
          setIsCommentSaving(false)
          setIsNewThread(false)
        }),
      )
      .catch((error) => {
        message.error(generateMessageError(error, 'FEEDBACK_SAVE_CHANGES_FAIL_MESSAGE'), 8)
        setIsCommentSaving(false)
        setIsNewThread(false)
      })
  }

  const renderCanSave = () => {
    const { data, ...rest } = settings
    return !_.isEmpty(rest) || (!_.isEmpty(rest) && !_.isEqual(defaultData, defaultSettings))
  }

  const handleEditName = (item) => {
    createLayout(
      'forecastoverallbudget',
      `${globalProjectionId}-${reportId}-coparations`,
      item.name,
      {
        ...item,
        name: newName,
      },
    )
      .then(() =>
        fetchLayoutList(
          'forecastoverallbudget',
          `${globalProjectionId}-${reportId}-coparations`,
        ).then(() => {
          message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
          setShowEdit(false)
          setRowId(false)
        }),
      )
      .catch((error) => {
        setShowEdit(false)
        setRowId(false)
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  const onDelete = (item, { ...props }) => {
    handleDelete({
      setIsLoading: setIsSaving,
      deleteLayout: () =>
        deleteLayout(
          'forecastoverallbudget',
          `${globalProjectionId}-${reportId}-coparations`,
          item.name,
        ),
      onRefetch: () =>
        fetchLayoutList('forecastoverallbudget', `${globalProjectionId}-${reportId}-coparations`),
      onClose: () => setIsSaving(false),
      ...props,
    })
  }

  const getAlreadyExist = () => {
    if (table) {
      const dataHash = !isEqual(hash, table) && hash !== null ? hash : table
      const json = Buffer.from(dataHash, 'base64').toString()
      const dataTable = JSON.parse(json)
      const { columns, cols, aggregatorName, rows, default_value, vals, default_format } =
        dataTable.config
      const data = layoutList.values.find((el) => {
        const { column_order, row_order, ...restProps } = el.config
        const dataConfig = {
          ...restProps,
          rows: getRowAuxName(restProps.rows, allDimensionsList),
          columns: getColsAuxName(restProps.columns, allDimensionsList),
        }
        return _.isEqual(
          {
            columns: columns ? columns : cols,
            rows,
            default_value: default_value ? default_value : vals[0],
            default_format: default_format ? default_format : DEFAULT_FORMAT_CREATE[aggregatorName],
          },
          dataConfig,
        )
      })

      if (data) {
        const { column_order, row_order, ...restProps } = data.config

        const filterData = {
          ...restProps,
          rows: getRowAuxName(restProps.rows, allDimensionsList),
          columns: getColsAuxName(restProps.columns, allDimensionsList),
        }

        return _.isEqual(
          {
            columns: columns ? columns : cols,
            rows,
            default_value: default_value ? default_value : vals[0],
            default_format: default_format ? default_format : DEFAULT_FORMAT_CREATE[aggregatorName],
          },
          filterData,
        )
      } else {
        return false
      }
    } else {
      return _.isEqual(defaultData, defaultSettings)
    }
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {showProgressBar && <ProgressBar isLoading={isComparisonLoading || tableLoading} />}
      </div>
      <TopTableActions
        setPeriodTableSettings={setPeriodTableSettings}
        periodTableSettings={periodTableSettings}
        onClickDownload={download}
        onClickSaveFav={() => setShowPopover(true)}
        visibleFav={showPopover}
        onClickSave={() =>
          handleSave({
            setIsLoading: setIsSaving,
            createLayout: () => onCreate(),
            onRefetch: () =>
              fetchLayoutList(
                'forecastoverallbudget',
                `${globalProjectionId}-${reportId}-coparations`,
              ),
            onRefresh: onRefetch,
            onClose,
          })
        }
        onClickCancelSaveFav={onClose}
        setFavouriteName={setFavouriteName}
        favouriteName={favouriteName}
        isLoading={isSaving}
        hasFavourite={layoutList?.values.length > 0}
        options={layoutList?.values.map((el) => {
          return { name: el.name, id: el.name, primary: el.primary }
        })}
        canSave={renderCanSave()}
        viewSelect={viewSelect}
        setViewSelect={(val) => {
          const aux = layoutList?.values.find((el) => el.name === val)
          setViewSelect(aux)
        }}
        alreadyExist={getAlreadyExist()}
        layoutLoading={isLayoutLoading}
        setPrimary={(data) =>
          handleSavePrimary({
            setIsLoading: setIsSaving,
            createLayout: () => onSavePrimary(data),
            onRefetch: () =>
              fetchLayoutList(
                'forecastoverallbudget',
                `${globalProjectionId}-${reportId}-coparations`,
              ),
            onClose: () => setIsSaving(false),
          })
        }
        onClickDeleteFav={(name) =>
          handleDelete({
            setIsLoading: setIsSaving,
            deleteLayout: () =>
              deleteLayout(
                'forecastoverallbudget',
                `${globalProjectionId}-${reportId}-coparations`,
                name,
              ),
            onRefetch: () =>
              fetchLayoutList(
                'forecastoverallbudget',
                `${globalProjectionId}-${reportId}-coparations`,
              ),
            onClose: () => setIsSaving(false),
          })
        }
        showComments={
          viewComment ||
          dataComments.filter(
            (el) => el.key === `${key}-table-comparison-${reportId}` && !el.resolved,
          ).length > 0
        }
        hasComment={hasComment}
        setHasComment={setHasComment}
        setViewComment={setViewComment}
        userDetail={loggedUser}
        settings={settings}
        setDataComments={setDataComments}
        dataComments={dataComments.filter(
          (el) => (el.key === `${key}-table-comparison-${reportId}` && !el.resolved) || !el.text,
        )}
        onRefetchComments={onRefetchComments}
        loadingComments={loadingComments}
        onCommentCreate={(text, usersIds, idComment, setIsNewThread) =>
          handleCreate({ text, usersIds, idComment, setIsNewThread })
        }
        isCommentSaving={isCommentSaving}
        removeNewComment={removeNewComment}
        currencyData={currencyData}
        onClickEditNameFav={() => setShowModalEdit(true)}
        onClckPreferences={() => setShowPreferenceModal(true)}
      />
      <Spin spinning={isComparisonLoading || tableLoading}>{renderTable()}</Spin>
      <FavouriteEditModal
        visible={showModalEdit}
        onClose={() => setShowModalEdit(false)}
        dataSource={layoutList.values}
        viewSelect={viewSelect}
        setIsSaving={setIsSaving}
        onSavePrimary={(item) => onSavePrimary(item)}
        onRefetch={() =>
          fetchLayoutList('forecastoverallbudget', `${globalProjectionId}-${reportId}-coparations`)
        }
        handleDelete={(item) => {
          if (layoutList.values.length > 1 && item.primary) {
            const filterItems = layoutList.values.filter((el) => el.name !== item.name)
            const newItem = filterItems[filterItems.length - 1]
            onDelete(item, {
              onSetPrimary: () =>
                createLayout(
                  'forecastoverallbudget',
                  `${globalProjectionId}-${reportId}-coparations`,
                  newItem.name,
                  { ...newItem, primary: true },
                ),
              setViewSelect: () => setViewSelect(newItem),
            })
          } else if (layoutList.values.length === 1) {
            onDelete(item, {
              onRefetch: () =>
                Promise.all([
                  fetchLayoutList(
                    'forecastoverallbudget',
                    `${globalProjectionId}-${reportId}-coparations`,
                  ),
                  onRefetch(),
                ]),
              setSettings: () =>
                setSettings({
                  ...settings,
                  vals: ['amount'],
                  cols: ['Proyecciones'],
                  rows: ['Linea de reporte'],
                  aggregatorName: 'Suma (Decimales)',
                }),
            })
          } else {
            onDelete(item, {})
          }
        }}
        handleEditName={(item) => handleEditName(item)}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        rowId={rowId}
        setRowId={setRowId}
        newName={newName}
        setNewName={setNewName}
      />
      <PreferencesTableModal
        visible={showPreferenceModal}
        onClose={() => setShowPreferenceModal(false)}
        onRefresh={onRefetch}
        setShowPreferenceModal={setShowPreferenceModal}
        allDimensionsList={allDimensionsList}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  dataComparativeForecastReport: forecast.selectors.getDataComparativeForecastReport(state),
  layoutList: control.selectors.getLayoutList(state),
  hasComment: configuration.selectors.getHasComment(state),
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  createLayout: control.actions.createLayout,
  fetchLayoutList: control.actions.fetchLayoutList,
  deleteLayout: control.actions.deleteLayout,
  setHasComment: configuration.actions.setHasComment,
  createComment: configuration.actions.createComment,
  removeNewComment: configuration.actions.removeNewComment,
}

export default connect(mapStateToProps, mapDispatchToProps)(ComparisonPivotTable)
